import { Grid, Typography, Box } from '@mui/material';
import PublicToolLayout from '../../components/public-tools/PublicToolLayout';
import ToolCard from '../../components/public-tools/ToolCard';

const TOOLS = [
  {
    title: 'Website Health Check',
    description: 'HTTPS, robots.txt, sitemap, page title, schema, Open Graph, and canonical tags — all in one scan.',
    route: '/tools/website-health-check',
  },
  {
    title: 'Page SEO Analyzer',
    description: 'Analyze title, meta description, heading structure, canonical, and noindex signals for any page.',
    route: '/tools/page-seo-analyzer',
  },
  {
    title: 'robots.txt Validator',
    description: 'Check if your robots.txt is accessible, well-formed, and contains a Sitemap directive.',
    route: '/tools/robots-txt-validator',
  },
  {
    title: 'Sitemap Validator',
    description: 'Validate your XML sitemap structure, URL count, and reachability.',
    route: '/tools/sitemap-validator',
  },
  {
    title: 'GSC Verification Signals',
    description: 'Detect Search Console DNS or HTML verification signals without claiming active property access.',
    route: '/tools/gsc-owner-verification-check',
  },
  {
    title: 'Schema / JSON-LD Detector',
    description: 'Find structured data markup (JSON-LD, Microdata, RDFa) and identify schema types present.',
    route: '/tools/schema-detector',
  },
  {
    title: 'AI Search Readiness',
    description: 'Check AI crawler access (GPTBot, ClaudeBot, PerplexityBot…), llms.txt, entity signals, and citation readiness.',
    route: '/tools/ai-crawling-readiness',
    badge: 'New',
  },
  {
    title: 'GA4 On-Page Validation',
    description: 'Inspect GA4 install signals, dataLayer, tracking opportunities, and readiness recommendations from page source only.',
    route: '/tools/ga4-onpage-validation',
    badge: 'New',
  },
  {
    title: 'Full SEO Diagnostic Report',
    description: 'All 7 diagnostics in one consolidated report delivered to your email. Submit your URL, get a reference number, and retrieve results online or via email.',
    route: '/tools/consolidated-report',
    badge: 'Report',
  },
];

export default function ToolsLandingPage() {
  return (
    <PublicToolLayout title="Free SEO Tools">
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Free SEO Diagnostics
        </Typography>
        <Typography variant="body1" color="text.secondary" maxWidth={600}>
          No account needed. Enter any public URL and get an instant analysis — completely free.
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {TOOLS.map((tool) => (
          <Grid item xs={12} sm={6} md={4} key={tool.route}>
            <ToolCard
              title={tool.title}
              description={tool.description}
              badge={(tool as { badge?: string }).badge}
              route={tool.route}
            />
          </Grid>
        ))}
      </Grid>
    </PublicToolLayout>
  );
}
